const { getElements } = window.BAO.Utils

class WishlistModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.handleSwitchList = this.handleSwitchList.bind(this)
    this.handleSwitchCreate = this.handleSwitchCreate.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.listeners.add(this.els.create.element, 'click', this.handleCreate)

    this.listeners.add(
      this.els['switch-list'].element,
      'click',
      this.handleSwitchList,
    )
    this.listeners.add(
      this.els['switch-create'].element,
      'click',
      this.handleSwitchCreate,
    )

    this.populateLists = this.populateLists.bind(this)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(swat => {
      this.checkLoggedIn()

      this.checkIsInWishlist()

      this.externalEls.trigger?.elements.forEach(el => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      onSuccess => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    this.checkIsInWishlist()
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-modal-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: trigger.dataset.productUrl,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      this.els.title.element.innerHTML = trigger.dataset.productTitle

      this.setAttribute('aria-hidden', false)
      document.body.classList.toggle('util-SiteOverflowed', true)

      this.els.submit.element.setAttribute(
        'data-product-id',
        trigger.dataset.productId,
      )
      this.els.submit.element.setAttribute(
        'data-variant-id',
        trigger.dataset.variantId,
      )
      this.els.submit.element.setAttribute(
        'data-product-url',
        trigger.dataset.productUrl,
      )

      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    }
  }

  populateLists (lists) {
    this.els.lists.element.innerHTML = ''

    lists.forEach((list, index) => {
      this.els.lists.element.innerHTML += `<div class="wsh-Modal_Field">
        <input class="wsh-Modal_Radio" type="radio" id="list${
          list.lid
        }" name="wishlist_list" value="${list.lid}"${
        index === 0 ? ' checked' : ''
      }>
        <label class="wsh-Modal_Label fz-14_160" for="list${list.lid}">${
        list.lname
      } (${list.cnt})</label>
      </div>`
    })

    if (lists.length === 0) {
      this.els['panel-create'].element.setAttribute('aria-hidden', false)
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['switch-list'].element.setAttribute('aria-hidden', true)
      this.els.newlist.element.value = 'My wishlist'
    } else {
      this.els['panel-create'].element.setAttribute('aria-hidden', true)
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['switch-list'].element.setAttribute('aria-hidden', false)
      this.els.newlist.element.value = ''
    }
  }

  handleSubmit () {
    const listChoice = getElements('[name="wishlist_list"]').find(
      el => el.checked,
    )

    this.addToWishlist(listChoice.value)
  }

  handleCreate () {
    const listConfig = {
      lname: this.els.newlist.element.value,
    }

    window._swat.createList(
      listConfig,
      newList => this.addToWishlist(newList.lid),
      this.wishlistError,
    )
  }

  handleSwitchList () {
    this.els['panel-create'].element.setAttribute('aria-hidden', true)
    this.els['panel-list'].element.setAttribute('aria-hidden', false)
  }

  handleSwitchCreate () {
    this.els['panel-create'].element.setAttribute('aria-hidden', false)
    this.els['panel-list'].element.setAttribute('aria-hidden', true)
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.els.submit.element.dataset.variantId),
      empi: parseInt(this.els.submit.element.dataset.productId),
      du: this.els.submit.element.dataset.productUrl,
    }

    window._swat.addToList(lid, product, this.handleClose, this.wishlistError)
  }

  checkIsInWishlist () {
    window._swat.fetchLists({
      callbackFn: lists => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )
        this.externalEls.count.elements.forEach(countEl => {
          countEl.setAttribute('aria-hidden', productCount === 0)
        })

        this.externalEls.trigger?.elements.forEach(el => {
          const matchedProduct = lists.find(list =>
            list.listcontents.find(
              product => product.empi === parseInt(el.dataset.productId),
            ),
          )

          if (matchedProduct) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedProduct.lid)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`)
  }
}

if (!customElements.get('wishlist-modal')) {
  customElements.define('wishlist-modal', WishlistModal)
}
